<template>
  <div class="am3-optin-panel">
    <div v-if="showPanel" class="am3-optin-panel__content">
      <div class="panel-header">

        <div class="close-button" @click="togglePanel">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </div>
      </div>

      <div class="opt-in-text">
        <h2 class="text-2xl font-bold mb-4" style="margin-bottom: 1rem;">The new look is here</h2>
        <p style="margin-bottom: 0.5rem;">
          Audience, Events & Data Capture (formerly Campaigns) have been redesigned - faster, more intuitive, and built
          around how you actually work. This is the first of many updates coming, including significant new features
          that have been months in the making.
        </p>
        <p style="margin-bottom: 0;">
          Not ready yet? Switch back to classic view anytime here or in your Settings.
        </p>
      </div>

      <!-- <ar-simple-button
        text="Join Early Access"
        type="purple"
        @click="handleOptIn"
        class="am3-optin-panel__button"
        size="sm"
      /> -->
      <div class="u-display-flex u-flex-flow-row u-margin-top-4 u-align-items-center switch-container">
        <p>Enable the new look</p>
        <am2-switch :value="isEarlyAccessEnabled" @input="updateToggleState" />
      </div>
    </div>

    <button @click="togglePanel" class="am3-optin-panel__trigger-button">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18 1.502a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.675 1.91 1.91l1.036.259a.75.75 0 0 1 0 1.455l-1.036.259c-.94.235-1.674.97-1.91 1.91l-.258 1.035a.75.75 0 0 1-1.456 0L17.014 8.9a2.63 2.63 0 0 0-1.91-1.91l-1.036-.26a.75.75 0 0 1 0-1.454l1.036-.26a2.63 2.63 0 0 0 1.91-1.91l.258-1.035A.75.75 0 0 1 18 1.502m0 3.096a4.1 4.1 0 0 1-1.404 1.404A4.1 4.1 0 0 1 18 7.406a4.1 4.1 0 0 1 1.404-1.404A4.1 4.1 0 0 1 18 4.598m-9-.096a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.814a3.75 3.75 0 0 0-2.576 2.575l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.575l-2.846-.814a.75.75 0 0 1 0-1.442l2.846-.813a3.75 3.75 0 0 0 2.576-2.576l.813-2.846A.75.75 0 0 1 9 4.502m0 3.48-.092.323a5.25 5.25 0 0 1-3.606 3.605l-.322.092.322.092A5.25 5.25 0 0 1 8.908 15.7l.092.322.092-.322a5.25 5.25 0 0 1 3.606-3.606l.322-.092-.322-.092a5.25 5.25 0 0 1-3.606-3.605zm7.5 7.02a.75.75 0 0 1 .712.513l.394 1.183c.15.448.5.8.948.949l1.183.394a.75.75 0 0 1 0 1.423l-1.183.394a1.5 1.5 0 0 0-.948.949l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.949l-1.183-.394a.75.75 0 0 1 0-1.423l1.183-.394c.447-.15.799-.501.948-.95l.395-1.182a.75.75 0 0 1 .711-.513m0 2.836a3 3 0 0 1-.915.914c.368.235.68.547.915.915.235-.368.547-.68.915-.915a3 3 0 0 1-.915-.914" clip-rule="evenodd" /></svg>
    </button>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../../utils/cookie.js';

export default {
  name: 'Am3OptinPanel',

  data() {
    return {
      showPanel: false,
      isEarlyAccessEnabled: true
    };
  },

  mounted() {
    this.checkOptInStatus();
  },

  methods: {
    checkOptInStatus() {
      const optOutCookie = getCookie('am3EarlyAccessOptOut');

      // Check if user has enabled early access and update the switch state
      this.isEarlyAccessEnabled = optOutCookie !== 'true';

      // Show full panel if user hasn't opted in or out yet
      if (optOutCookie !== 'true' && optOutCookie !== 'false') {
        this.showPanel = true;
      } else {
        // Show button if user has opted in or out
        this.showPanel = false;
      }
    },

    togglePanel() {
      // Toggle the panel visibility when the button is clicked
      this.showPanel = !this.showPanel;
    },

    updateToggleState(value) {
      this.isEarlyAccessEnabled = value;

      // Set cookie for opt-in based on toggle value
      setCookie('am3EarlyAccessOptOut', value ? 'false' : 'true', {
        path: '/'
        // No maxAge (permanent)
      });

      window.location.reload(); // reload once the cookie is set

      // Close the panel after a short delay
      setTimeout(() => {
        this.showPanel = false;
      }, 500);
    },

    handleOptIn() {
      // Set cookie for opt-in
      setCookie('am3EarlyAccessOptOut', 'false', {
        path: '/'
        // No maxAge (permanent)
      });

      // Update toggle state
      this.isEarlyAccessEnabled = true;

      // Hide panel after opt-in
      this.showPanel = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.am3-optin-panel__trigger-button {
  border-radius: 100%;
  background-color: #edf1f5;
  margin: 0 auto 8px;
  max-width: 36px;
  max-height: 36px;
  width: 100%;
  height: 100%;
  min-height: 36px;
  border: 0;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    color: #8e97a6;
    &:hover {
      color: #9333ea;
    }
  }
  &:hover {
    color: #9333ea;
  }
}

.am3-optin-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // margin-bottom: 16px;
  box-sizing: border-box;

  @media screen and (max-width: 767px) {
    // display: none ;
    flex-direction: row;
    align-items: baseline;
    justify-content: start;
    font-size: 1rem;
    button {
      margin-left: 0;
      margin-right: 10px;
    }
  }

  &__content {
    position: absolute;
    left: 76px;
    top: auto;
    border-radius: 8px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: start;
    background-color: #fff;
    box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1), 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
      0px 0px 0px 1px rgba(0, 0, 0, 0.05);
    width: 480px;
    z-index: 1000;
    bottom: 1rem;

    @media screen and (max-width: 767px) {
      top: auto;
      left: 90px;
      position: fixed;
      bottom: 1rem;
    }

    @media screen and (max-height: 767px) {
      top: auto;
      left: 90px;
      position: fixed;
      bottom: 1rem;
    }

    @media screen and (min-height: 767px) {
      top: auto;
      left: 84px;
      position: fixed;
      bottom: 9.5rem;
    }
  }

  &__title {
    margin: 8px 0;
    color: #222;
  }

  &__button {
    width: 100%;
    margin-top: 8px;
  }

  &__trigger-button {
    width: 100%;
    margin-bottom: 1rem;

    .beaker-icon {
      // width: 16px;
      // height: 16px;
    }
  }

  .switch-container > p {
    margin-right: 16px;
  }

  .panel-header {
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    margin-bottom: 16px;

    .close-button {
      cursor: pointer;
      color: #6b7280;

      svg {
        width: 20px;
        height: 20px;
      }

      &:hover {
        color: #1f2937;
      }
    }
  }

  .early-access-badge {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    background-color: #f4f0fa;
    color: #9333ea;
    font-size: 10px;
    font-weight: bold;
    border-radius: 8px;

    > svg {
      margin-right: 4px;
      width: 12px;
      height: 12px;
    }
  }

  .opt-in-text {
    h2 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      color: #222;
      line-height: 1.4;
    }
  }
}
</style>
